module.exports = {
  siteDescription: 'Breaking K-Pop and K-Drama News, Exclusives, and Videos',
  shareImage: 'https://0.soompi.io/soompi-web/share-soompi-en.jpg',
  ccpaConsent: {
    modalTitle: 'Do not sell my personal information',
    label: 'Personalized ads',
    privacyLinkCta: 'privacy policy',
    descriptionOptIn: 'You have opted in to the sharing of your data for the purposes of personalized advertisements. This means that you may receive advertisements tailored to you. For more information, please see our {0}.',
    descriptionOptOut: 'You have opted out to the sharing of your data for the purposes of personalized advertisements. This means you may still receive advertisements but they may be less relevant. For more information, please see our {0}.'
  },
  cookieConsent: {
    banner: 'We use cookies to improve our services, personalize content and display ads based on your interests. By continuing to use this website, you are giving us your consent to do this.',
    title: 'Cookies Setting',
    tabs: {
      whatCookie: {
        title: 'What are Cookies?',
        toggle: '',
        content: [
          'When you visit any web site, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalised web experience.',
          'Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.'
        ]
      },
      siteFunctions: {
        title: 'Site Functionality Cookies',
        toggle: 'Always on',
        content: [
          'We use cookies to provide you with the features and intended user experience of the Sites (e.g. these cookies can help Us with keeping track of user preferences). We use cookies to enable our security features and to help Us detect activities that violate our policies (e.g. these cookies can help Us prevent spam). We use cookies to verify your account and personalize your experience (e.g. these cookies can help Us keep you logged in as you navigate between Site pages).'
        ]
      },
      performance: {
        title: 'Performance, Analytics and Research',
        toggle: '',
        content: [
          'We use cookies to collect information on how the Sites are used and to report on the Sites usage statistics for the improvement of Our services (e.g. these cookies can help Us count visits, page views, traffic sources, and better understand how you and other users use Our Sites, and identify features that could be improved).'
        ]
      },
      socialMedia: {
        title: 'Social Media',
        toggle: '',
        content: [
          'We use cookies that are set by a range of social media services that We have added to Our Sites to enable you to share Our content with your friends and networks. They are capable of tracking your browser across other sites. This may impact the content and messages you see on other websites you visit (e.g. these cookies can help the social media services up a profile of your interests).'
        ]
      },
      advertising: {
        title: 'Advertising and Remarketing',
        toggle: '',
        content: [
          'We and our advertising partners may collect information using cookies to help make the advertising you see on the Sites and elsewhere on the internet more relevant to you, and to measure the effectiveness of the advertising on the Sites (e.g. these cookies can help Us and our advertising partners show you useful and relevant ads more effectively).'
        ]
      }
    }
  },
  sorts: {
    latest: 'Latest',
    popular: 'Popular',
    trending: 'Trending'
  },
  sortpages: {
    latest: 'All latest posts',
    popular: 'All popular posts',
    trending: 'All trending posts'
  },
  buttons: {
    submitTip: 'Submit News Tip',
    submitTipTitle: 'Click to submit a news tip.',
    watchNow: 'Watch Now',
    loadMore: 'Load More',
    seeAll: 'See All',
    allowAll: 'Allow All',
    learnMore: 'Learn More',
    save: 'Save',
    cancel: 'Cancel',
    nightMode: 'Night Mode Toggle',
    customize: 'Customize',
    update: 'Update Changes',
    manage: 'Manage Rakuten ID',
    backHome: 'Back to Home',
    submit: 'Submit',
    close: 'Close'
  },
  dates: {
    justNow: 'Just now',
    yesterday: 'Yesterday',
    min: '{0} min ago',
    mins: '{0} mins ago',
    hour: '{0} hour ago',
    hours: '{0} hours ago',
    day: '{0} day ago',
    days: '{0} days ago',
    week: '{0} week ago',
    weeks: '{0} weeks ago'
  },
  search: {
    title: 'Search',
    textbox: 'Search Articles',
    noResult: 'Sorry, we\'re unable to find result for {0}',
    error: 'Sorry, we are having trouble fetching results from the server. Please try again.',
    result: 'Search results for "{0}"',
    tagsLabel: 'Search tags for "{0}"',
    postsLabel: 'Search posts for "{0}"',
    loading: 'Getting results...'
  },
  login: {
    title: 'Log in to Soompi and start engaging!',
    facebookPrompt: 'Log in with Facebook',
    googlePrompt: 'Log in with Google',
    tocPrompt: 'Please agree with our terms before creating the account.',
    toc: 'By creating an account, you agree with Soompi\'s {0} and {1}. Soompi is part of Rakuten Viki family.',
    privacyLinkCta: 'Privacy Policy',
    termsOfUseLinkCta: 'Terms of Use'
  },
  logout: {
    title: 'Log out'
  },
  profile: {
    title: 'Profile',
    dropdownWelcomeTitle: 'Welcome back, {0}!',
    edit: 'Edit Profile',
    displayName: 'Display Name',
    share: 'Share your stories',
    storyLimitWarning: 'Text should be no more than 500 characters',
    email: 'Email Address (Invisible to others)',
    manage: 'Manage your account settings like email address, social account, and password through Rakuten ID portal.',
    editImage: 'Change<br/>Photo',
    update: 'Update Changes',
    updateError: 'Error in updating profile. Please try again',
    updateSuccess: 'Profile updated successfully!',
    privacySection: 'Privacy'
  },
  general: {
    explore: 'Explore',
    spotlight: 'Spotlight',
    related: 'Related',
    popular: 'Popular',
    trending: 'Trending',
    trendingNow: 'Trending Now',
    latestNews: 'Latest News',
    watchNow: 'Watch Now',
    mustRead: 'Must Read',
    similarArticle: 'Similar Articles',
    comments: 'Comments',
    shareit: 'Share it on',
    authors: 'Articles by {0}'
  },
  footer: {
    links: {
      about: 'About Us',
      terms: 'Terms of Use',
      privacy: 'Privacy Policy',
      cookie: 'Cookies Policy',
      copyright: 'Copyright Policy',
      help: 'Help Center',
      adInfo: 'Advertisement Info',
      guide: 'Site Guidelines',
      ccpa: 'Do not sell my Personal Information',
      jobs: 'Jobs',
      apps: 'Apps'
    },
    family: 'Soompi is part of the {0} family.',
    language: 'Language',
    english: 'English',
    spanish: 'Español',
    follow: 'Follow Us',
    sitemap: 'Sitemap'
  },
  rss: {
    linkBack: 'The post {0} appeared first on {1}',
    pagination: 'Page {0}'
  },
  notFound: 'The page you are looking for seems to have gotten lost!',
  submitTip: {
    title: 'Submit News Tip',
    text1: 'Got some breaking news or photos about K-Pop or K-Drama? Tell our news team now and we’ll follow the lead!',
    text2: 'Please include a description as well as a URL if applicable.',
    formFieldsRequired: 'All fields are required.',
    formName: 'Name',
    formEmail: 'Email',
    formContent: 'What is the tip?',
    alertFail: 'Failed to submit your tip, please try again later.',
    alertSuccess: 'Thank you for your tip! Our editorial team will look at them shortly.'
  },
  reactions: {
    title: 'How does this article make you feel?',
    dialogTitle: 'Hold On!',
    dialogText: 'You’re one step away from expressing your emotion for this article, please log in to engage with the rest.'
  },
  comment: {
    dialogTitle: '',
    loginCta: 'Please {0} to Soompi to join the conversation!',
    loginCtaButton: 'login'
  }
}



// WEBPACK FOOTER //
// ./shared-assets/i18n/lang/en.js